module.exports = __webpack_public_path__ + "img/our-02.7fc51ff3.png";